var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTouring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4083 0.193836C12.665 0.0054418 12.9961 -0.049452 13.2998 0.0460142L23.2998 3.18887C23.7165 3.31983 24 3.70608 24 4.14287V23C24 23.5523 23.5523 24 23 24H1C0.447715 24 0 23.5523 0 23V12.5238C0 11.9715 0.447715 11.5238 1 11.5238H4V8.33334C4 7.78106 4.44772 7.33334 5 7.33334H15C15.5523 7.33334 16 7.78106 16 8.33334V22H22V4.8768L14 2.36252V5.19048C14 5.74277 13.5523 6.19048 13 6.19048C12.4477 6.19048 12 5.74277 12 5.19048V1.00001C12 0.681603 12.1516 0.38223 12.4083 0.193836ZM14 22V9.33334H6V22H14ZM4 22V13.5238H2V22H4ZM19 7.33334C19.5523 7.33334 20 7.78106 20 8.33334V18.8095C20 19.3618 19.5523 19.8095 19 19.8095C18.4477 19.8095 18 19.3618 18 18.8095V8.33334C18 7.78106 18.4477 7.33334 19 7.33334ZM8 12.5238C8 11.9715 8.44772 11.5238 9 11.5238H11C11.5523 11.5238 12 11.9715 12 12.5238C12 13.0761 11.5523 13.5238 11 13.5238H9C8.44772 13.5238 8 13.0761 8 12.5238ZM8 15.6667C8 15.1144 8.44772 14.6667 9 14.6667H11C11.5523 14.6667 12 15.1144 12 15.6667C12 16.219 11.5523 16.6667 11 16.6667H9C8.44772 16.6667 8 16.219 8 15.6667ZM8 18.8095C8 18.2572 8.44772 17.8095 9 17.8095H11C11.5523 17.8095 12 18.2572 12 18.8095C12 19.3618 11.5523 19.8095 11 19.8095H9C8.44772 19.8095 8 19.3618 8 18.8095Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTouring);
export default __webpack_public_path__ + "static/media/touring.5440cce6.svg";
export { ForwardRef as ReactComponent };